import React,{useRef,useState,useEffect} from 'react'
import TextField from 'components/TextField'
import Picker from 'react-month-picker'
import { useSelector,useDispatch } from 'react-redux'
import moment from 'moment'
import 'react-month-picker/css/month-picker.css';
import { setFilterIndividualAll } from 'redux/actions/report'
import AutoCompleteSelect from 'components/Select'
import { MuiThemeProvider, createMuiTheme,withStyles,makeStyles } from '@material-ui/core/styles'
import {FormControl} from '@material-ui/core'
import { Button } from '@material-ui/core';
import { modalToggleReset } from 'redux/actions/general'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
const themeButton = createMuiTheme({ 
    palette: { 
        primary: {
            main:'#ffc466',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main:'#ff6e79',
            contrastText: '#FFFFFF',
        },
    } 
})
const MonthBox=(props)=>{
    const _handleClick=(e)=> {
        props.onClick && props.onClick(e);
    }
    return(
        <TextField
            label='Deal period'
            value={props.textPeriode}
            onFocus={_handleClick}
            color='primary'
            variant='outlined'
            size='small'
            name='name'
            style={{marginBottom:20}}
        />
    )
}
export default function Filter_individual_all({modal_data,profile}) {
    // const [dateRange, setDateRange] = useState([]);
    const [pickerKey, setPickerKey] = useState(0);
    const formatDateForAPI = (date) => {
        if (!date) return "0";
        const options = { day: "2-digit", month: "long", year: "numeric" };
        return date.toLocaleDateString("en-US", options);
    };
    
    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}${month}${day}`;
      };
    
    // Set default date range
    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 1); // 1st January of this year
    
    const [dateRange, setDateRange] = useState([startOfYear, today]);

    const startDateText = formatDateForAPI(dateRange[0]);
    const endDateText = formatDateForAPI(dateRange[1]);
    const startDate = formatDate(dateRange[0]);
    const endDate = formatDate(dateRange[1]);
    const [state, setstate] = useState({
        rangeValue:{from: {year: parseInt(moment().format('YYYY')), month:1}, to: {year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('M'))}},
        textPeriode:`Jan. ${moment().format('YYYY')} - ${moment().format('MMM')}. ${moment().format('YYYY')}`,
        periode:{fromMonth:1,toMonth:parseInt(moment().format('M'))},
        tribes:[]
    })
    const dispatch = useDispatch()
    const report = useSelector(state => state.report)
    const master = useSelector(state => state.master)
    const pickRange=useRef(null)
    const pickerLang = {
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        from: 'From', to: 'To',
    }
    const max=moment().add(10,'year').format('YYYY')
    const min=moment().subtract(10,'year').format('YYYY')
    let {filter_individual_all}=report
    useEffect(() => {
        const formattedTextPeriode = startDateText && endDateText ? `${startDateText} - ${endDateText}` : 'All Period';
        setstate({
            rangeValue:filter_individual_all.rangeValue,
            textPeriode:formattedTextPeriode,
            periode:filter_individual_all.periode,
            tribes:filter_individual_all.tribes
        })
    }, [])
    const makeText = m => {
        if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year)
        return '?'
    }
    const _handleClickRangeBox=(e)=>{
        pickRange.current.show()
    }
    const handleRangeChange=(value, text, listIndex)=> {
       
    }
    const handleRangeDissmis=(value)=> {
        let fromMonth=value.from.month
        let toMonth=value.to.month
        const formattedTextPeriode = startDateText && endDateText ? `${startDateText} - ${endDateText}` : 'All Period';
        setstate({
            ...state,
            periode:{fromMonth:fromMonth,toMonth:toMonth},
            rangeValue:value,
            textPeriode:formattedTextPeriode
        })
        // dispatch(setFilterSalesVisit({
        //     periode:{fromMonth:fromMonth,toMonth:toMonth},
        // }))
        // dispatch(setFilterSalesVisit({
        //     rangeValue:value
        // }))
        // dispatch(setFilterSalesVisit({
        //     textPeriode:pickerLang.months[value.from.month-1] + '. ' + value.from.year + ' - '+pickerLang.months[value.to.month-1] + '. ' + value.to.year
        // }))
        
    }
    const onClickApply=async ()=>{
        const formattedTextPeriode = startDateText && endDateText ? `${startDateText} - ${endDateText}` : 'All Period';
        await dispatch(setFilterIndividualAll({
            periode:state.periode,
        }))
        await dispatch(setFilterIndividualAll({
            rangeValue:state.rangeValue
        }))
        await dispatch(setFilterIndividualAll({
            textPeriode:formattedTextPeriode
        }))
        await dispatch(setFilterIndividualAll({tribes:state.tribes}))
        let new_tribes=[]
        state.tribes.map((d)=>{
            new_tribes.push(d.id)
        })
        await modal_data.action(`/${profile.id}/${startDate}/${endDate}/${new_tribes.length > 0 ? new_tribes.join(',') : 0}`);
        dispatch(modalToggleReset());
        //  await modal_data.action(`/${profile.id}/${state.periode.fromMonth}/${state.periode.toMonth}/${state.rangeValue.from.year}/${new_tribes.length>0?new_tribes.join(','):0}`)
        // dispatch(modalToggleReset())
    }
    return (
        <div>
        <div className="add-proposal__field">
            <FormControl variant="outlined" size="small" fullWidth>
                <Flatpickr
                    key={pickerKey}
                    options={{ mode: "range", dateFormat: "Y-m-d" }}
                    value={dateRange}
                    onChange={(date) => setDateRange(date)}
                    render={({ value, defaultValue, ...props }, ref) => (
                        <TextField
                            {...props}
                            inputRef={ref}
                            variant="outlined"
                            size="small"
                            fullWidth
                            label="Date Range"
                            placeholder="All Period"
                            value={value || ""}
                            InputLabelProps={{ shrink: true }}
                        />
                    )}
                />
            </FormControl>
        </div>
            {/* <Picker
                ref={pickRange}
                years={{min: {year:parseInt(min),month:12},max:{year:parseInt(max),month:12}}}
                value={state.rangeValue}
                lang={pickerLang}
                theme="light"
                onChange={handleRangeChange}
                onDismiss={handleRangeDissmis}
            >
                <MonthBox textPeriode={state.textPeriode} value={makeText(state.rangeValue.from) + ' - ' + makeText(state.rangeValue.to)} onClick={_handleClickRangeBox} />
            </Picker> */}
            <AutoCompleteSelect
                onChange={(event,value)=>setstate({...state,tribes:value})}
                options={master.tribes}
                value={state.tribes}
                getOptionLabel={(option) => option.text}
                label="Tribe"
                multiple
            />
            <div style={{textAlign:'right'}}>
                <MuiThemeProvider theme={themeButton}>
                    <Button onClick={onClickApply} size="small" color="primary" className='btn-remove-capital btn-rounded' variant="contained">Apply Filter</Button>
                </MuiThemeProvider>
            </div>
            <br/>
        </div>
    )
}
